// The preferred-provider ribbon. Not StarIcon (which marks the owner) or AcceptedPlanIcon (which marks
// an accepted health plan), since a provider can carry either of those alongside this one.
// Defaults to currentColor so it follows the nav's active state.
export default function AwardIcon({
  width = 14,
  height = 14,
  color = 'currentColor',
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <circle cx='7' cy='5' r='4' stroke={color} strokeWidth='1.5' />
      <circle cx='7' cy='5' r='1.5' fill={color} />
      <path d='M4.5 8.2L3.5 13L7 11.2L10.5 13L9.5 8.2' stroke={color} strokeWidth='1.5' strokeLinejoin='round' />
    </svg>
  );
}
